export default {
  ["Дата начала продаж {date}"]: (date?: string) =>
    `Satış başlangıç tarihi ${date}`,
  ["Закрыть"]: "Kapat",
  ["Рекламный слайдер"]: "Reklam slaytı",
  ["Используйте клавиши стрелок для переключения слайдов."]:
    "Slaytları değiştirmek için ok tuşlarını kullanın.",
  ["Ещё"]: "Daha fazla",
  ["Ещё {number}"]: (number?: number) => `${number} tane daha`,
  ["Убрать"]: "Kaldır",
  ["Меню"]: "Menü",
  ["От {min} до {max} символов"]: (data?: { min: number; max: number }) =>
    `${data?.min} ile ${data?.max} karakter arasında`,
  ["Минимум {count} символ"]: (count?: number) => `En az ${count} karakter`,
  ["Выбрать из списка"]: "Listeden seç",
  ["развернуто"]: "Genişletildi",
  ["свернуто"]: "Daraltıldı",
  ["Модальное окно"]: "Modal pencere",
  ["Выбран"]: "Seçildi",
  ["Не выбран"]: "Seçilmedi",
  ["Свернуть"]: "Daralt",
  ["Эксклюзив"]: "Özel",
  ["Хит продаж"]: "Çok satan",
  ["Новинка"]: "Yeni",
  ["Все книги, получившие эту награду"]: "Bu ödülü kazanan tüm kitaplar",
  ["Предыдущий слайд"]: "Önceki slayt",
  ["Следующий слайд"]: "Sonraki slayt",
  ["Оценить книгу на {count} балл из 5"]: (count?: number) =>
    `Kitabı ${count} üzerinden 5 ile değerlendir`,
  ["Снять оценку"]: "Puanı kaldır",
  ["{star} звезда из 5"]: (star?: number) => `5 üzerinden ${star} yıldız`,
  ["предыдущий таб"]: "Önceki sekme",
  ["следующий таб"]: "Sonraki sekme",
};
